import { Arrow } from "@sphtech/dmg-design-system";

export const readmoreIcon = <Arrow size={15} strokeWidth={1.8} />;
